export class MarkCustomerAsVulnerableModel {
  public reason: string;
}
